import api from "./api";

// 查询banner
export const getBannerList = () => {
  return api("get", `/v1/management/mini-config/banner/list`);
};

// banner保存
export const postBannerSave = params => {
  return api("post", `/v1/management/mini-config/banner/save`, params);
};

// 课程列表
export const postCourseList = params => {
  return api("post", `/v1/management/mini-config/course/list`, params);
};

// 课程保存
export const postCourseSave = params => {
  return api("post", `/v1/management/mini-config/course/save`, params);
};

// 课程搜索
export const getCourseSearch = params => {
  return api("get", `/v1/management/mini-config/course/${params}`);
};

// 首页功能模块配置
export const getHModuleConfig = () => {
  return api("get", `/v1/management/mini-config/home-module-config`);
};

// 首页功能模块配置编辑
export const postHModuleConfig = params => {
  return api("post", `/v1/management/mini-config/home-module-config`, params);
};
